import React, { ReactNode } from 'react';
import { Box, FormField, Input, InputProps, Text } from '@wix/design-system';
import { StatusAlertSmall as Alert } from '@wix/wix-ui-icons-common';

interface FormInputProps extends InputProps {
  dataHook?: string;
  label?: ReactNode;
  suffix?: ReactNode;
  statusMessage?: ReactNode;
}
export const FormInput: React.FC<FormInputProps> = ({
  label,
  suffix,
  value,
  onBlur,
  status,
  statusMessage,
  onChange,
  dataHook,
}) => {
  return (
    <FormField
      dataHook={`${dataHook}__label`}
      label={
        <Text size="small">
          <Box verticalAlign="middle">
            {label}
            {suffix}
          </Box>
        </Text>
      }
    >
      <Input
        dataHook={`${dataHook}__input`}
        value={value}
        onBlur={onBlur}
        status={status}
        onChange={onChange}
      />
      {statusMessage && status === 'error' && (
        <Text skin="error" size="small" dataHook={`${dataHook}__error-message`}>
          <Box marginTop="SP1" verticalAlign="top" display="inline-flex">
            <Box flexGrow={1} marginRight="SP1">
              <Alert />
            </Box>
            {statusMessage}
          </Box>
        </Text>
      )}
    </FormField>
  );
};
